import clsx from "clsx";
import { ArrowBackSVGIcon } from "components/SVGIcons";
import useDeviceType from "hooks/useDeviceType";
import { ICompany } from "models/HaulPay";

type BillToCompanyProps = {
  company: ICompany;
  onSelectCompany?: VoidFunction;
};

export default function BillToCompanyItem({ company, onSelectCompany }: BillToCompanyProps) {
  const { isDesktop } = useDeviceType();

  return company.dba ? (
    <button
      type="button"
      className="flex items-center cursor-pointer m-1 py-3 px-3.5 hover:bg-popover desktop:rounded-md text-sm desktop:border-none border-b border-dashed border-tertiary w-full company-btn"
      onClick={onSelectCompany ?? onSelectCompany}>
      <div className="flex flex-1 flex-col items-start">
        <span className="text-left">{company.dba}</span>
        <span>
          {!!company.mc && `MC# ${company.mc}`}
          {!!company.mc && !!company.dot && " , "}
          {!!company.dot && `DOT# ${company.dot}`}
        </span>
        {!!company.credit_approved && (
          <span
            className={clsx(
              {
                "text-success": company.credit_approved === "approved",
                "text-warning": ["pending", "needs_review"].includes(company.credit_approved),
                "text-error": company.credit_approved === "declined"
              },
              "uppercase"
            )}>
            {company.credit_approved.replace(/_/g, " ")}
          </span>
        )}
      </div>
      {!isDesktop && <ArrowBackSVGIcon className="flex-none size-6" />}
    </button>
  ) : null;
}
